import React, { Dispatch, ReactNode, SetStateAction, useContext } from "react";
import {
  Alert,
  Box,
  Button,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { DataContext } from "../../Context/ContextWrapper";

const steps = ["Appuntamento", "Paziente", "Note", "Dettaglio"];

const AlertAbortBox = (props: {
  showAlert: boolean;
  handleTotalClose: () => void;
  handleAlert: () => void;
  handleCancellation?: () => void;
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Alert
        severity="warning"
        sx={{
          border: "1px solid #e65100",
          marginTop: "20px",
          marginBottom: "20px",
          alignContent: "center",
          alignItems: "center",
          "& .MuiAlert-icon": {
            marginLeft: 2,
            fontSize: 40,
          },
        }}
        action={
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginRight: 2,
            }}
          >
            <Button variant="containedError" onClick={props.handleAlert}>
              No
            </Button>
            <Button
              variant="containedCustom"
              onClick={() => {
                // props?.handleCancellation();
                // problema sulla total close per il delay della cancellazione
                props.handleTotalClose();
              }}
            >
              Si
            </Button>
          </Box>
        }
      >
        <Box>
          <Typography
            component="div"
            marginTop={"20px"}
            marginLeft={"20px"}
            marginRight={"10px"}
            marginBottom={"20px"}
            fontSize={"20px"}
            fontWeight={"bold"}
          >
            Attenzione, vuoi annullare questa prenotazione?
          </Typography>
        </Box>
      </Alert>
    </Box>
  );
};

const ReservationSteppers = ({
  children,
  activeStep,
  areFieldsCompiled,
  showAlert,
  handleSummary,
  setActiveStep,
  handleClose,
  // handleCancellation,
  handleAlert,
  loading
}: {
  children: ReactNode;
  activeStep: number;
  areFieldsCompiled: boolean;
  showAlert: boolean;
  handleSummary: (status: number) => Promise<void>;
  setActiveStep: Dispatch<SetStateAction<number>>;
  handleClose: () => void;
  // handleCancellation: () => void;
  handleAlert: () => void;
  loading: boolean; 
}) => {
  const context = useContext(DataContext);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Box>
      <>
        <Stepper
          activeStep={activeStep}
          sx={{
            "& .MuiStepConnector-line": {
              borderColor: "rgba(0, 0, 0, 0.2)",
            },
            "& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line": {
              borderColor: "#1A7234",
            },
            "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line": {
              borderColor: "#1A7234",
            },
          }}
        >
          {steps.map((label, index) => {
            return (
              <Step
                key={label}
                sx={{
                  "& .MuiStepIcon-root": {
                    color: "rgba(0, 0, 0, 0.2)",
                  },
                  "& .MuiTypography-root": {
                    color: "rgba(0, 0, 0, 0.5)",
                  },
                  "& .Mui-completed .MuiStepIcon-root": {
                    color: "#1A7234",
                  },
                  "& .Mui-completed .MuiTypography-root": {
                    color: "#1A7234",
                  },
                  "& .Mui-active .MuiStepIcon-root": {
                    color: "#2E83C4",
                    outline: "2px solid #FFF",
                    outlineOffset: "-3px",
                    borderRadius: 4,
                  },
                  "& .Mui-active .MuiTypography-root": {
                    color: "#2E83C4",
                    fontWeight: "bold",
                  },
                  marginTop: 4,
                  marginBottom: 4,
                }}
              >
                <StepLabel>
                  <Typography
                    sx={{
                      color: "#024E88",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: "700",
                      lineHeight: "157%",
                      letterSpacing: "0.1px",
                    }}
                  >
                    {label}
                  </Typography>
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <React.Fragment>
          {!showAlert ? (
            children
          ) : (
            <AlertAbortBox
              handleTotalClose={handleClose}
              // handleCancellation={handleCancellation}
              handleAlert={handleAlert}
              showAlert={showAlert}
            />
          )}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            {activeStep === 0 ? (
              <Button
                variant="outlinedError"
                disabled={showAlert || loading}
                onClick={handleAlert}
                sx={{ mr: 1 }}
              >
                Annulla
              </Button>
            ) : (
              <Box
                sx={{ display: "flex", gap: 2, justifyContent: "flex-start" }}
              >
                <Button
                  variant={"outlinedError"}
                  disabled={showAlert || loading}
                  onClick={handleAlert}
                >
                  Annulla
                </Button>
              </Box>
            )}
            {activeStep === 1 || activeStep === 2 ? (
              <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
                <Button
                  variant={"outlinedCustom"}
                  disabled={showAlert || loading}
                  onClick={handleBack}
                >
                  Indietro
                </Button>
                <Button
                  variant={"contained"}
                  disabled={showAlert  || !areFieldsCompiled || loading}
                  onClick={handleNext}
                >
                  Avanti
                </Button>
              </Box>
            ) : activeStep === steps.length - 1 ? (
              <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
                <Button
                  variant={"outlinedCustom"}
                  disabled={showAlert || loading}
                  onClick={handleBack}
                >
                  Indietro
                </Button>
                <Button
                  variant={"contained"}
                  disabled={showAlert || !areFieldsCompiled || loading}
                  onClick={async () => {
                    if (context?.statusAvanzamentoPrenotazione === 3) {
                      await handleSummary(3);
                    } else {
                      await handleSummary(0);
                    }
                  }}
                >
                  Concludi
                </Button>
              </Box>
            ) : (
              <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
                <Button
                  variant={"contained"}
                  disabled={showAlert || loading}
                  onClick={handleNext}
                >
                  Avanti
                </Button>
              </Box>
            )}
          </Box>
        </React.Fragment>
      </>
    </Box>
  );
};

export { ReservationSteppers };
